import { InfraResponse } from "~/api/_common/InfraResponse"
import { defineFetcher } from "~/api/_common/defineFetcher"
import { PUT } from "~/api/_common/http"

import { BasePutStudentProfileBody } from "./_put-types/BasePutStudentProfileBody"

/** PUT:/api/student/profileから送られる型 */
export type PutStudentProfile = InfraResponse<unknown>

export const fetchPutStudentProfile = defineFetcher((body: PutStudentProfileBody): Promise<PutStudentProfile> => {
  return PUT("/student/profile", body)
})

/**
 * useFormで型を指定する際に以下のように使用するための型(`ProfilePutParameter`でやるとundefinedで怒られる)
 *
 * ```ts
 * const { watch, setValue, handleSubmit } = useForm<PutStudentProfileBodyMap["internship_experiences_interest"]>({
 *   defaultValues: { occupation: selected },
 * })
 * ```
 */
export type PutStudentProfileBodyMap = Required<BasePutStudentProfileBody>

/**
 * PUT:/api/student/profileに送る型
 * ※ 複数のパラメーターを指定することはできない
 */
export type PutStudentProfileBody = BasePutStudentProfileBody
